import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogrishneshwar() {



  const cardData =
  {
    keyword: 'Mumbai to Grishneshwar Cab',
    heading: 'Shambhu Cabs: Mumbai to Grishneshwar Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Grishneshwar Cab services, providing safe, comfortable, and hassle-free travel for devotees, families, friends, and corporate travelers visiting the holy shrine of Grishneshwar. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Grishneshwar with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes your pilgrimage or outstation trip convenient, stress-free, and memorable. For trusted, comfortable, and safe travel, Shambhu Cabs is your preferred choice for Mumbai to Grishneshwar cab services.',

    top: 'Top Places to Visit in Grishneshwar with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Grishneshwar Temple",
    "description": "Grishneshwar Temple, one of the 12 Jyotirlingas of Lord Shiva, is a revered pilgrimage site near Ellora in Maharashtra. The temple showcases intricate Maratha architecture with detailed carvings, sculptures, and a sacred sanctum. Devotees visit to seek blessings, perform rituals, and participate in festivals like Maha Shivaratri. Its spiritual significance, historical value, and serene atmosphere make it a must-visit for pilgrims and tourists alike."
  },
  {
    "title": "Ellora Caves",
    "description": "Located close to Grishneshwar, Ellora Caves are a UNESCO World Heritage Site featuring rock-cut temples and monasteries from Buddhist, Hindu, and Jain traditions. Visitors can explore intricate carvings, impressive sculptures, and ancient architectural marvels. The proximity to Grishneshwar Temple allows a combined spiritual and cultural experience."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves, a set of 12 rock-cut Buddhist shrines near Ellora, offer insight into ancient Buddhist art and architecture. The caves contain intricate sculptures of deities, decorative motifs, and meditation halls. They provide a tranquil setting and complement a visit to Grishneshwar Temple."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort, about 15 km from Grishneshwar, is a historic hill fort known for its strategic design, massive gates, and steep inclines. Visitors can explore the fort’s complex architecture, secret passages, and enjoy panoramic views of the surrounding landscape. It adds a historic adventure dimension to a spiritual visit."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Often called the 'Mini Taj Mahal,' Bibi Ka Maqbara in Aurangabad is a beautiful mausoleum built in memory of Dilras Banu Begum. Its white marble structure, intricate carvings, and gardens provide a stunning visual experience. Pilgrims visiting Grishneshwar often include this architectural gem in their itinerary."
  },
  {
    "title": "Jayakwadi Dam",
    "description": "Located near Aurangabad, Jayakwadi Dam is one of the largest irrigation dams in Maharashtra. Surrounded by scenic landscapes and wildlife, it offers boating, bird-watching, and picnic opportunities. The dam provides a peaceful escape from the pilgrimage route."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki, an ancient water mill in Aurangabad, is famous for its ingenious engineering and historical significance. The mill’s water channels, gardens, and surrounding architecture offer a blend of culture, history, and technical marvels. It is a peaceful and educational stop near Grishneshwar."
  },
  {
    "title": "Salim Ali Lake",
    "description": "Salim Ali Lake, named after the famous ornithologist, is a serene spot near Aurangabad for bird-watching, photography, and relaxation. Visitors can enjoy nature walks and observe migratory birds in a tranquil environment, making it a calm retreat after temple visits."
  },
  {
    "title": "Panchakki Garden",
    "description": "Adjacent to the historic Panchakki mill, the garden area offers landscaped spaces, water channels, and shaded areas for relaxation. It’s ideal for families and tourists looking to enjoy a quiet environment amidst historic surroundings."
  },
  {
    "title": "Ellora Garden",
    "description": "Ellora Garden near the caves offers well-maintained lawns, flower beds, and seating areas where visitors can relax after exploring the rock-cut temples. The garden provides a scenic backdrop for photography and a peaceful atmosphere close to Grishneshwar Temple."
  }
],




"services": [
  {
    "name": "Mumbai Grishneshwar Taxi",
    "description": "Mumbai Grishneshwar Taxi offers reliable and comfortable travel from Mumbai to Grishneshwar temple with professional drivers and timely pickups."
  },
  {
    "name": "Jyotirlinga Cab Mumbai",
    "description": "Jyotirlinga Cab Mumbai provides a dedicated pilgrimage taxi service for visiting Grishneshwar, ensuring a safe and hassle-free journey."
  },
  {
    "name": "One Way Cab Mumbai Grishneshwar",
    "description": "One Way Cab Mumbai Grishneshwar is perfect for travelers seeking a single-direction ride, with affordable fares and on-time service."
  },
  {
    "name": "Affordable Grishneshwar Cab",
    "description": "Affordable Grishneshwar Cab ensures cost-effective travel from Mumbai to the temple without compromising comfort or safety."
  },
  {
    "name": "Mumbai Aurangabad Grishneshwar Taxi",
    "description": "Mumbai Aurangabad Grishneshwar Taxi provides long-distance travel services with professional drivers, ideal for pilgrimage trips or leisure travel."
  },
  {
    "name": "Pilgrimage Cab Mumbai Grishneshwar",
    "description": "Pilgrimage Cab Mumbai Grishneshwar specializes in temple visits, offering comfortable vehicles for family and group journeys."
  },
  {
    "name": "SUV Cab Mumbai Grishneshwar",
    "description": "SUV Cab Mumbai Grishneshwar offers spacious rides for families or groups, ensuring comfort during long-distance travel."
  },
  {
    "name": "Sedan Taxi Mumbai Grishneshwar",
    "description": "Sedan Taxi Mumbai Grishneshwar provides an economical and comfortable option for small families or solo travelers."
  },
  {
    "name": "24x7 Cab Mumbai Grishneshwar",
    "description": "24x7 Cab Mumbai Grishneshwar ensures taxi availability at any hour, catering to early morning or late-night departures."
  },
  {
    "name": "Fast Cab Mumbai Grishneshwar",
    "description": "Fast Cab Mumbai Grishneshwar optimizes routes to provide quick and efficient travel from Mumbai to the temple."
  },
  {
    "name": "Temple Darshan Cab Mumbai",
    "description": "Temple Darshan Cab Mumbai offers specialized services for visiting Grishneshwar, including guided routes and comfortable transport."
  },
  {
    "name": "Premium Cab Mumbai Grishneshwar",
    "description": "Premium Cab Mumbai Grishneshwar provides luxury sedans and SUVs for travelers seeking extra comfort and style."
  },
  {
    "name": "Safe Taxi Mumbai Grishneshwar",
    "description": "Safe Taxi Mumbai Grishneshwar focuses on passenger safety with well-maintained vehicles and trained drivers."
  },
  {
    "name": "Mumbai Grishneshwar Round Trip Cab",
    "description": "Mumbai Grishneshwar Round Trip Cab is ideal for travelers looking for a return journey service with convenience and comfort."
  }
],

"tableData": [
  ["Mumbai Grishneshwar Taxi", "Jyotirlinga Cab Mumbai"],
  ["One Way Cab Mumbai Grishneshwar", "Affordable Grishneshwar Cab"],
  ["Mumbai Aurangabad Grishneshwar Taxi", "Pilgrimage Cab Mumbai Grishneshwar"],
  ["SUV Cab Mumbai Grishneshwar", "Sedan Taxi Mumbai Grishneshwar"],
  ["24x7 Cab Mumbai Grishneshwar", "Fast Cab Mumbai Grishneshwar"],
  ["Temple Darshan Cab Mumbai", "Premium Cab Mumbai Grishneshwar"],
  ["Safe Taxi Mumbai Grishneshwar", "Mumbai Grishneshwar Round Trip Cab"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Grishneshwar Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Grishneshwar cab services, ideal for pilgrimage trips, family journeys, and comfortable long-distance travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to ensure a smooth and comfortable ride from Mumbai to Grishneshwar."
  },
  {
    "WhyChooseheading": "Experienced Pilgrimage Route Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with Mumbai to Grishneshwar routes, ensuring safe driving, timely arrivals, and a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included for your Mumbai to Grishneshwar cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, route guidance, and any trip-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans based on your Mumbai to Grishneshwar journey requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience for passengers."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Grishneshwar travel smooth, comfortable, and worry-free."
  }
]
































  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Grishneshwar?',
    answer: 'Yes, Shambhu Cabs offers comfortable and reliable cab services from Mumbai to Grishneshwar, making your pilgrimage journey to the Grishneshwar Jyotirlinga temple smooth and hassle-free.',
  },
  {
    question: 'How can I book a cab from Mumbai to Grishneshwar?',
    answer: 'You can easily book a cab from Mumbai to Grishneshwar through our website, mobile app, or by calling our 24x7 customer support team for seamless booking.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Grishneshwar cab bookings?',
    answer: 'Shambhu Cabs offers a range of vehicles for your Mumbai to Grishneshwar trip, including sedans, SUVs, luxury cars, and Tempo Travellers for family or group trips.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Grishneshwar journey?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with the route to Grishneshwar, ensuring a safe, comfortable, and timely journey.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Grishneshwar trip?',
    answer: 'Yes, you can specify your preferred pickup and drop-off locations within Mumbai and Grishneshwar, offering you flexibility and convenience during your journey.',
  },
  {
    question: 'Is the Mumbai to Grishneshwar cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers 24x7 service for your pilgrimage journey from Mumbai to Grishneshwar, ensuring you can travel at any time that fits your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Grishneshwar trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow strict safety and hygiene measures to ensure your well-being during the trip.',
  },
  {
    question: 'What payment options are available for Mumbai to Grishneshwar cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for all cab bookings from Mumbai to Grishneshwar.',
  },
  {
    question: 'Is customer support available during my Mumbai to Grishneshwar trip?',
    answer: 'Yes, Shambhu Cabs provides 24x7 customer support to assist you throughout your journey from Mumbai to Grishneshwar.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Shukla',
    feedback: 'Our pilgrimage trip from Mumbai to Grishneshwar was truly peaceful thanks to Shambhu Cabs. The driver was friendly and professional, and the car was comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Patil',
    feedback: 'I highly recommend Shambhu Cabs for trips to religious places like Grishneshwar. The service was impeccable, and the journey was very smooth.',
    rating: 5,
  },
];















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const mumbaiGrishneshwarCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Grishneshwar Cab",
  "serviceType": "Outstation / Pilgrimage Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-grishneshwar-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Grishneshwar cab services. Book affordable SUV, sedan, and premium cabs for one-way, round trip, or pilgrimage travel, available 24×7.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "540",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-grishneshwar-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, Grishneshwar, India" }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Grishneshwar Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Grishneshwar cab services with Shambhu Cabs. Affordable SUV, sedan, and premium cabs for one-way, round trip, or pilgrimage travel, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Grishneshwar Taxi, Jyotirlinga Cab Mumbai, One Way Cab Mumbai Grishneshwar, Affordable Grishneshwar Cab, Mumbai Aurangabad Grishneshwar Taxi, Pilgrimage Cab Mumbai Grishneshwar, SUV Cab Mumbai Grishneshwar, Sedan Taxi Mumbai Grishneshwar, 24x7 Cab Mumbai Grishneshwar, Fast Cab Mumbai Grishneshwar, Temple Darshan Cab Mumbai, Premium Cab Mumbai Grishneshwar, Safe Taxi Mumbai Grishneshwar, Mumbai Grishneshwar Round Trip Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(mumbaiGrishneshwarCabSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitogrishneshwar;